import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BasicTextArea, BasicInput,BasicFieldCheckbox, BaasicModal, BaasicButton, BaasicFieldDropdown } from 'core/components';
import { ApplicationEditLayout, Content } from 'core/layouts';
import { CorporateContactEdit} from 'application/corporate/components';
import { toPhoneNumber, emailRecipientTypes } from 'core/utils';
function CorporateEditTemplate({ editView }) {
    const {
        contentLoading,
        form,
        contactEditModal,
        onAddContact,
        authorization,
        contacts,
        facilities,
        onDeleteContact,
        reportingIntervalTypeStore,
        rootStore
    } = editView;

    let facilitiesActions = facilities && facilities.slice().sort((a, b) => a.name.localeCompare(b.name)).map(facility => {
        return(
            <div key={facility.id}>
                <a onClick={() => rootStore.routerStore.goTo(
                'master.app.main.facility.preview',{ id: facility.id })}>
                    {facility.name}
                </a>
            </div>
        );
    });

    let contactsRows = contacts && contacts.map(contact => {
        return (<tr key={contact.id}>
            <td>
                {contact.name}
            </td>
            <td className="c-pointer table--clickable" onClick={() => onAddContact(contact)}>
                {contact.lastName}
            </td>
            <td className="c-pointer table--clickable" onClick={() => onAddContact(contact)}>
                {contact.contactDepartments && contact.contactDepartments.map(cd => cd.name).join(", ")}
            </td>
            <td>
                {toPhoneNumber(contact.phone)}
            </td>
            <td>
                {contact.email}
            </td>
            <td>
                {contact.position}
            </td>
            <td className="type--center">
                <span className={'u-icon u-icon--sml' + ( contact.specialOrders ? ' u-icon--active' : '')}></span>
            </td>
            <td className="u-cursor--default type--left">
                {emailRecipientTypes.map((setting) => {
                   return contact[setting.field] && contact[setting.field] !== '' && <div className={'status--include is-'  + contact[setting.field]}>{setting.name}</div>
                })}
            </td>
            <td className="type--right">
                <BaasicButton
                    className="btn btn--icon u-mar--right--sml"
                    icon="u-icon u-icon--edit u-icon--sml"
                    label="Edit"
                    onlyIcon={true}
                    onClick={() => onAddContact(contact)}
                ></BaasicButton>

                <BaasicButton
                    authorization={
                        authorization ? authorization.delete : null
                    }
                    className="btn btn--icon is-delete"
                    icon="u-icon u-icon--delete u-icon--sml"
                    label="Delete"
                    onlyIcon={true}
                    onClick={() => onDeleteContact(contact)}
                ></BaasicButton>
            </td>
        </tr>)
    }); 

    return (
        <ApplicationEditLayout store={editView}>
            <Content loading={contentLoading} >
                <div className="row">
                    <div className="col col-sml-12 col-lrg-8">
                        <div className="card card--form card--primary card--med">
                        <h4 className="form__title form__title--preview">General Info</h4>
                            <div className="row">
                                <div className="form__group.col col col-lrg-6 u-mar--bottom--sml">
                                    <div className="form__group">
                                        <BasicInput field={form.$('name')} />
                                    </div>
                                    <div className="form__group">
                                        <BasicTextArea multiLineEdit={true} field={form.$('specialRequests')} />
                                    </div>
                                </div>
                                <div className="form__group col-lrg-6">
                                    <div className="form__group col col-lrg-12">
                                        <BasicTextArea multiLineEdit={true} field={form.$('description')} />   
                                    </div>
                                    <div className="form__check col u-mar--top--sml u-mar--left--sml">
                                        <BasicFieldCheckbox className="has-fake-label" field={form.$('specialOrders')}/><label className="fake-label">Approval needed for Special orders</label>
                                    </div>
                                    <div className="form__check col u-mar--top--sml u-mar--left--sml">
                                        <BasicFieldCheckbox className="has-fake-label" field={form.$('approvalRequiredExtraSupplies')}/><label className="fake-label">Approval Required for Extra Supplies</label>
                                    </div>
                                    <div className="form__check col u-mar--top--sml u-mar--left--sml">
                                        <BasicFieldCheckbox className="has-fake-label" field={form.$('requiredSecondPayor')}/><span className="fake-label">2nd Payor Check Required</span>
                                    </div>
                                    <div className="form__check col u-mar--top--sml u-mar--left--sml">
                                        <BasicFieldCheckbox className="has-fake-label"  field={form.$('isActive')}/><span className="fake-label">Is Active</span>
                                    </div>
                                </div>                               
                            </div>
                            <h4 className="form__title form__title--preview">Reporting</h4>                                              
                            <div className="row">
                                <div className="form__group.col col col-lrg-6 u-mar--bottom--sml">
                                    <div className="form__group">
                                        <BaasicFieldDropdown field={form.$('reportingIntervalTypeId')} store={reportingIntervalTypeStore} allowEmpty={true} />
                                    </div>      
                                </div>
                                <div className="form__group.col col col-lrg-6 u-mar--bottom--sml">
                                    <div className="form__group">
                                        <BasicTextArea multiLineEdit={true} field={form.$('reportingInstructions')} />
                                    </div>    
                                </div>
                            </div>                            
                            <div>
                                {contactsRows && contactsRows.length != 0 &&
                                <div className="u-mar--bottom--med">
                                    <h4 className="form__title form__title--preview">Contacts</h4>   
                                    <table className="table--preview">
                                         <colgroup>
                                                <col />
                                                <col />
                                                <col />
                                                <col />
                                                <col />
                                                <col />
                                                <col className='w--75--px' />
                                                <col className='w--140--px' />
                                                <col width="80" />
                                            </colgroup>
                                        <thead>
                                            <tr>
                                                <th className="type--left">First Name</th>
                                                <th className="type--left">Last Name</th>
                                                <th className="type--left">Department</th>
                                                <th className="type--left">Phone</th>
                                                <th className="type--left">Email</th>
                                                <th className="type--left">Note</th>
                                                <th className="type--center">Special Order</th>
                                                <th className="type--left">Include On</th>
                                                <th className="type--right">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>{contactsRows}</tbody>
                                    </table>
                                </div>
                                }
                                <BaasicModal modalParams={contactEditModal} className="modal__content modal--med">
                                    <CorporateContactEdit /> 
                                </BaasicModal> 
                                <div>
                                    <BaasicButton
                                        authorization={authorization ? authorization.update : null}
                                        className="btn btn--base btn--primary"
                                        label='Add Contact'
                                        onClick={() => onAddContact()}>
                                    </BaasicButton> 
                                </div>
                                <div className="u-mar--top--med">
                                    {facilitiesActions}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Content>
        </ApplicationEditLayout>
    )
}

CorporateEditTemplate.propTypes = {
    editView: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(CorporateEditTemplate);
